import { Heading } from "~/components";

function HeadingTitle(props) {
  return <Heading size={1} {...props} />;
}

export { HeadingTitle };
